export default (values) => {

  const errors = {};

  if (!values.date_range) errors.date_range = true;
  if (values.date_range && values.date_range.split(',').length !== 2) errors.date_range = 'Start date and End date must not be equal';
  
  return errors;
  
}